<template>
  <div id="shit" style="height: 70vh">
    <v-container style="height: 70vh" class="d-flex align-items-center">
      <v-row>
        <v-col class="d-flex justify-center">
          <v-card max-width="400" class="align-self-center mx-4 pa-4">
            <v-card-title>{{ pageName }} page not available!</v-card-title>
            <v-card-subtitle>Soon, but not now.</v-card-subtitle>
            <v-card-text>This project revolves on Profile Complete process. Would you like to view that instead?</v-card-text>
            <v-card-actions>
              <v-btn color="orange" @click="$router.push('/my-account/profile')" text>VIEW PROFILE</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  computed: {
    pageName() {
      const name = this.$route.path.replaceAll('/', '').replaceAll('%20', ' ').split(' ')
      for (let i = 0; i < name.length; i++) {
        name[i] = name[i][0].toUpperCase() + name[i].substr(1)
      }
      return name.join(' ')
    },
  },
}
</script>

<style></style>
